<template>
  <div class="main-navbar custom-zain-bar">
    <div class="container-fluid">
      <div
        class="d-flex align-items-center justify-content-between py-4 pb-2 flex-column flex-lg-row gap-3"
      >
        <div
          class="d-flex justify-content-between w-100 align-items-center flex-column flex-lg-row gap-3"
        >
          <div class="d-flex justify-content-between align-items-center">
            <router-link :to="{ name: 'Home' }" class="brand-logo">
              <img
                src="@/assets/images/logos/logo.png"
                alt="Zaytoon"
                class="img-fluid"
                style="height: 50px; width: 100px"
              />
            </router-link>

            <img
              src="@/assets/images/logos/zain.png"
              alt="Zain"
              class="img-fluid d-lg-none"
              style="height: 25px"
            />
          </div>

          <div class="w-100 d-flex align-items-center justify-content-between">
            <form
              @submit.prevent="search"
              class="search-container ms-0 ms-lg-5"
            >
              <input
                type="text"
                v-model="q"
                placeholder="بحث..."
                class="search-input-modern"
              />
            </form>

            <div class="btns-container d-flex align-items-center">
              <div
                v-if="!$store.getters.isLoggedIn && !demoModeActive"
                class="d-flex justify-content-end gap-1 gap-md-3"
              >
                <a
                  :href="zainLandingPage"
                  class="btn btn-zain btn-light text-dark rounded-pill px-2 btn-sm fw-bold d-flex justify-content-center align-items-center"
                >
                  <i class="la la-lock me-1"></i> الإشتراك
                </a>

                <router-link
                  :to="{ name: 'Login' }"
                  class="btn btn-login btn-outline-light rounded-pill px-2 btn-sm d-flex justify-content-center align-items-center"
                >
                  الدخول <i class="la la-arrow-left ms-1"></i>
                </router-link>
              </div>

              <div
                v-else
                class="d-flex align-items-center justify-content-end gap-1"
              >
                <!-- <button
                  v-if="operator === 'zain' && $store.getters.isLoggedIn"
                  @click="unsubscribe"
                  class="btn btn-link text-light text-decoration-none btn-sm"
                >
                  إلغاء الإشتراك
                </button> -->
                <router-link
                  :to="{ name: 'Profile' }"
                  class="text-light d-flex align-items-center justify-content-center"
                >
                  <i class="la la-user-circle la-2x"></i>
                </router-link>
              </div>
            </div>
          </div>

          <div class="d-none d-lg-flex align-items-center gap-3">
            <img
              src="@/assets/images/logos/zain.png"
              alt="Zain"
              class="img-fluid d-none d-lg-block"
              style="height: 25px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      q: "",
      operator: process.env.VUE_APP_PORTAL_OPERATOR,
      zainLandingPage: "https://dsplp.sd.zain.com/af-lp/?p=4335864896",
      demoModeActive: process.env.VUE_APP_DEMO_MODE_ACTIVE == "true",
      unsubscriptionLoading: false,
    };
  },

  setup() {
    const store = useStore();
    const toast = useToast();

    const logout = () => {
      store.dispatch("LOGOUT_USER");
      store.commit("UPDATE_MINIMIZED_PLAYER_SHOW", false);
      store.commit("CLOSE_TRACKLIST", {});
      // router.push({ name: 'LoginInfo' })
      window.location.assign("/");
    };

    return {
      toast,
      logout,
    };
  },

  mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.q = params.q;
  },

  methods: {
    search() {
      this.$router.push({ name: "Search", query: { q: this.q } });
    },

    unsubscribe() {
      if (window.confirm("هل تريد إلغاء اﻹشتراك حقا؟")) {
        this.unsubscribeUser();
      }
    },

    unsubscribeUser() {
      this.unsubscriptionLoading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation {
              unsubscribeUser {
                message
                code
                success
                payload
              }
            }
          `,
          // Parameters
          variables: {
            //
          },
        })
        .then((data) => {
          // Result
          console.log(data.data.unsubscribeUser);
          if (data.data.unsubscribeUser.success) {
            this.toast.success(data.data.unsubscribeUser.message);
            this.logout();
          } else {
            this.toast.error(data.data.unsubscribeUser.message);
          }
          this.unsubscriptionLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.unsubscriptionLoading = false;
          this.reportError();
        });
    },

    reportError(error) {
      let { graphQLErrors } = error;

      if (
        graphQLErrors &&
        graphQLErrors[0].extensions.category === "authentication"
      ) {
        this.toast.warning("إنتهت صلاحية الجلسة، الرجاء إعادة تسجيل الدخول");

        this.logout();
      }
    },
  },
};
</script>

<style scoped>
.main-navbar {
  background-image: url(../../assets/images/bg-zain.png);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  background-color: transparent;
}

.main-navbar::after {
  content: "";
  position: absolute;
  background-image: url(../../assets/images/clip-path-zain-group.png);
  background-repeat: no-repeat;
  background-size: contain;
  width: 280px;
  height: 100%;
  z-index: 0;
  bottom: 0;
  right: -5px;
}

@media (max-width: 990px) {
  .main-navbar .container-fluid div div {
    width: 100%;
  }
  .main-navbar::after {
    background-size: cover;
    height: 95%;
    width: 100%;
    background-position: 0 0;
    right: -25px;
  }
}

.custom-zain-bar {
  direction: rtl;
  color: white;
  min-height: 95px;
  display: flex;
  align-items: center;
}

.container-fluid {
  z-index: 100;
  margin: 0 70px;
}

@media (max-width: 990px) {
  .custom-zain-bar {
    padding-top: 15px;
  }
  .container-fluid {
    margin: 0;
  }
}

.search-container {
  max-width: 400px;
  margin: 0;
  position: relative;
}

@media (max-width: 990px) {
  .search-container {
    max-width: 100%;
    width: 100%;
  }
}

.search-input-modern {
  width: 250px;
  text-align: right;
  background: rgb(0 0 0 / 50%);
  backdrop-filter: blur(5px);
  border: none;
  border-radius: 20px;
  padding: 5px 20px;
  color: white;
  font-size: 0.9rem;
  outline: none;
}

@media (max-width: 990px) {
  .search-input-modern {
    width: 100%;
  }
}

.search-input-modern::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.btn {
  width: auto;
}

@media (min-width: 990px) {
  .btns-container {
    margin-left: 15px;
  }
  .btn {
    width: 115px;
  }
}

.btn-outline-light {
  border: 1px solid rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
}

.btn-light {
  font-size: 0.85rem;
}

.btn-zain {
  background-color: #ffffff !important;
  color: #cb2d3e !important;
  transition: all 0.3s ease-in-out;
}

.btn-zain:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  background-color: #f8f9fa !important;
}

.btn-zain:hover i {
  animation: unlock-wiggle 0.5s ease;
}

.btn-login {
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  color: #ffffff !important;
  transition: all 0.3s ease-in-out;
  background-color: rgb(255 255 255 / 4%);
  backdrop-filter: blur(3px);
}

.btn-login:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: #ffffff !important;
  color: #ffffff !important;
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

.btn-login:hover i {
  transform: translateX(-5px);
  transition: transform 0.3s ease;
}

@keyframes unlock-wiggle {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-15deg);
  }
  75% {
    transform: rotate(15deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.separator {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.3);
}

.brand-logo img {
  filter: brightness(0) invert(1);
}
</style>